import React, { useState } from 'react';
import { Button } from '@mui/material';
import { Search } from 'react-feather';
import AdminMultiSearch from '../AdminMultiSearch';

export const SearchAllButton: React.FC = () => {
  const [multiSearchOpen, setMultiSearchOpen] = useState(false);

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<Search size={20} />}
        onClick={() => setMultiSearchOpen(true)}
        sx={{
          borderColor: 'rgba(59, 57, 108, 0.15)',
          textTransform: 'none',
        }}
      >
        Search All (Cmd+K)
      </Button>
      <AdminMultiSearch
        open={multiSearchOpen}
        onClose={() => setMultiSearchOpen(false)}
      />
    </>
  );
};
